import FalconCloseButton from 'components/common/FalconCloseButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from '../../hooks/useToken';
import { useForm } from 'react-hook-form';
import { useToast } from 'context/providers/ToastProvider';

const ModalRenovarLicencia = ({
    licencias,
    cicloFacturacion,
    idLicencia,
    showModalRenovar,
    setShowModalRenovar,
    setPolizasRelacionadas,
    usuariosNube,
    setUsuariosNube
}) => {
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const { reset, handleSubmit, register, formState: { errors } } = useForm();
    const [procesandoModal, setProcesandoModal] = useState(false);
    const [ordenDetalleRenovacion, setOrdenDetalleRenovacion] = useState([]);
    /**
     * Renovar Licencia
     * @param {any} values
     */
    const renovarLicencia = async (values) => {
        console.log(values);
        const response = await fetch("/api/licencia/renovarlicencia/?id=" + idLicencia + "&values=" + encodeURIComponent(values), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data["table1"]);
            if (data["table1"][0].iResponseType == 1) {
                //getInformacionDetalladaLicenciaByID();
                showSuccessToast(data["table1"][0].vMessage);

                //se actualizan unicamente los campos modificados.
                licencias.dUpdatedDate = data["table2"][0].dUpdatedDate;
                licencias.vUpdatedUser = data["table2"][0].vUpdatedUser;
                licencias.dInicioLicenciaUso = data["table2"][0].dInicioLicenciaUso;
                licencias.dDiasTranscurridos = data["table2"][0].dDiasTranscurridos;
                licencias.dFinLicenciaUso = data["table2"][0].dFinLicenciaUso;
                licencias.dDiasFaltantes = data["table2"][0].dDiasFaltantes;
                licencias.idCatCicloFacturacion = data["table2"][0].idCatCicloFacturacion;

                if (licencias.idCatTipoLicencia == 1 || licencias.idCatTipoLicencia == 2 || licencias.idCatTipoLicencia == 4)
                    setPolizasRelacionadas(data["table3"]);
                else if (licencias.idCatTipoLicencia == 3)
                    setUsuariosNube(data["table3"]);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalRenovar(false);
        setProcesandoModal(false);
        reset();
    };


    /**
     * Submit de renovar
     * @param {any} data
     */
    const onSubmitRenovar = data => {
        setProcesandoModal(true);
        if (data.idCatCicloFacturacion == 4 && licencias.idCatTipoLicencia == 3) {
            showErrorToast('No es posible asignar un ciclo de facturación permanente a este tipo de licencia');
            setProcesandoModal(false);
        }
        else
            renovarLicencia(JSON.stringify(data));

    };

    /**
    * Obtiene detalles
    */
    const ObtenerListaUsuariosNubeAkasia = async () => {

        const response = await fetch("/api/licencia/ObtenerListaUsuariosNubeAkasia/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {

            console.log(response);
            const data = await response.json();

            setUsuariosNube(data);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    //Renovar Poliza
    const ObtenerListaOrdenDetalleRenovacion = async () => {
        const response = await fetch("/api/licencia/ObtenerListaOrdenDetalleRenovacion/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            setOrdenDetalleRenovacion(data);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }

    };

    return (
        <Modal
            show={showModalRenovar}
            onHide={() => setShowModalRenovar(false)}
            onShow={() => { ObtenerListaUsuariosNubeAkasia(); ObtenerListaOrdenDetalleRenovacion(); }}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form noValidate onSubmit={handleSubmit(onSubmitRenovar)}>
                <Modal.Header>
                    <Modal.Title>Renovar Licencia {licencias.vDescripcionTipo}</Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalRenovar(false); reset() }} />

                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Verifica y completa la siguiente informaci&oacute;n.
                            <hr></hr>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Ciclo facturaci&oacute;n</Form.Label>
                                <Form.Select
                                    aria-label="Default select"
                                    defaultValue={licencias.idCatCicloFacturacion}
                                    isInvalid={!!errors.idCatCicloFacturacion}
                                    {...register("idCatCicloFacturacion",
                                        {
                                            required: true
                                        })
                                    }
                                >
                                    {cicloFacturacion.map((ciclo, index) => {
                                        return (<option key={index} value={ciclo.idCatCicloFacturacion}>{ciclo.vDescripcionCiclo} - {ciclo.iNumeroDias} d&iacute;as</option>)
                                    })}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {errors.idCatCicloFacturacion && errors.idCatCicloFacturacion.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Selecciona la orden del pago de la p&oacute;liza</Form.Label>
                                <Form.Label className="fs--1">Solo podr&aacute;n aplicarse renovaciones con &oacute;rdenes con fecha de pago de m&aacute;ximo 3 d&iacute;as.</Form.Label>
                                <Form.Select
                                    aria-label="Default select"
                                    isInvalid={!!errors.idOrdenDetalle}
                                    {...register("idOrdenDetalle",
                                        {
                                            required: true
                                        })
                                    }
                                >
                                    <option value="">Selecciona la orden</option>
                                    {ordenDetalleRenovacion.map((od, index) => {
                                        return (<option key={index} value={od.idOrdenDetalle}>{od.vCodigoBarras} - Odn #{od.idOrden} - {od.dFechaVenta} - {parseFloat(od.dPrecioUnitarioImpuestos).toLocaleString("es-MX", {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2,
                                            style: 'currency', currency: 'MXN'
                                        })} {od.vMoneda}</option>)
                                    })}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {errors.idOrdenDetalle && errors.idOrdenDetalle.message}
                                </Form.Control.Feedback>
                            </Form.Group>

                        </Col>
                    </Row>
                    {licencias.idCatTipoLicencia == 3 &&
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Usuario Nube Akasia a Renovar</Form.Label>
                                    <Form.Select
                                        aria-label="Default select"
                                        isInvalid={!!errors.idUsuarioNubeAkasia}
                                        {...register("idUsuarioNubeAkasia",
                                            {
                                                required: true
                                            })
                                        }
                                    >
                                        {usuariosNube.map((una, index) => {
                                            return (<option key={index} value={una.idUsuarioNubeAkasia}>{una.vNombre} </option>)
                                        })}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.idUsuarioNubeAkasia && errors.idUsuarioNubeAkasia.message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setShowModalRenovar(false); reset() }} variant='primary' >Cerrar</Button>
                    {procesandoModal ? <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button> : <Button type="submit" variant='success' >R E N O V A R</Button>}
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

ModalRenovarLicencia.propTypes = {

    idLicencia: PropTypes.string,
    licencias: PropTypes.object,
    cicloFacturacion: PropTypes.array,
    showModalRenovar: PropTypes.bool,
    setShowModalRenovar: PropTypes.func,
    setPolizasRelacionadas: PropTypes.func,
    usuariosNube: PropTypes.array,
    setUsuariosNube: PropTypes.func
};
export default ModalRenovarLicencia;